import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-avantages-courtier-brokins',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './avantages-courtier-brokins.component.html',
  styleUrls: ['./avantages-courtier-brokins.component.css']
})
export class AvantagesCourtierBrokinsComponent implements OnInit {
  title = 'Avantages de passer par un courtier';
  subtitle = '';
  // encode spaces and accents in filename
  heroImage = 'assets/static_pages_images/Assurance%20Cr%C3%A9dit.jpg';

  breadcrumbs = [
    { label: 'Avantages à passer par un courtier Brokins', link: undefined }
  ];

  prevPage = {
    title: 'Notre Approche',
    link: '/notre-approche'
  };

  nextPage = {
    title: 'Notre Histoire',
    link: '/qui-sommes-nous'
  };

  constructor(private router: Router) {}

  ngOnInit(): void {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}
